import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  abcenseReportData: {
    head:[],
    body:[]
  },
  CsvData:[],
  isAbsenceReportLoading:false
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SUCCESS_ABSENCE_RPORT:
      var data=[]
        data = action.data.map(i => {
            return [i.date,i.name,i.email,i.systemNames, i.businessUnit, i.department, i.location,i.agentInstalledOn]
          })
        return{
          ...state,
          abcenseReportData: {
            head:[ 
            { label: "Date", align: "left" },
            { label: "Name", align: "left" },
            { label: "Email", align: "left" },
            { label: "System Names", align: "left" },
            { label: "Business Unit", align: "left",isFilter: true, filterVal: null , index: 4 },
            { label: "Department", align: "left" ,isFilter: true, filterVal: null , index: 5},
            { label: "Location", align: "left",isFilter: true, filterVal: null , index: 6 },
            { label: "Agent Installed On", align: "center" },
           ],
            body: data
          },
        } 
  case types.FAILED_ABSENCE_REPORT: 
      return{
        ...state,
        abcenseReportData: {
              head:[ 
                { label: "Date", align: "left" },
                { label: "Name", align: "left" },
                { label: "Email", align: "left" },
                { label: "System Names", align: "left" },
                { label: "Business Unit", align: "left",isFilter: true, filterVal: null , index: 4 },
                { label: "Department", align: "left" ,isFilter: true, filterVal: null , index: 5},
                { label: "Location", align: "left",isFilter: true, filterVal: null , index: 6 },
                { label: "Agent Installed On", align: "center" },
               ],
              body:[]
          },
      }
  case types.LOADING_ABSENCE_REPORT: 
      return{
        ...state,
        isAbsenceReportLoading:action.data
      }
  
    default:
      return state
  }
  
}
export default reducer
